<template>
  <v-container fluid>
    <v-layout row>
      <Header title="Reklamačný poriadok" subtitle="www.duris.info" />
    </v-layout>
    <v-layout row wrap align-center justify-center fill-height class="pt-5">
      <v-flex xs12 sm6 md6 lg6>
        <p>
          <b>Právo kupujúceho na reklamovanie chybného tovaru:</b>
        </p>
        <p>
          Kupujúci obdrží k nákupu daňový doklad, ktorý slúži zároveň ako záručný
          list. Pri zistení závady u zakúpeného tovaru má kupujúci právo závadu
          reklamovať pri prevzatí tovaru, alebo v záručnej 24mes. I dobe. Predávajúci
          zodpovedá za to, že predávaný tovar má požadovanú kvalitu a množstvo.
          Reklamáciu nie je možné uplatniť na chyby, ktoré zapríčinil kupujúci po
          prevzatí tovaru vlastnou dopravou, chybnou montážou a neodbornou úpravou
          tovaru, a chyby, ktoré vznikli bežným opotrebovaním alebo používaním v
          prostredí, na ktoré nie je tovar určený.
        </p>
        <p>
          <b>Miesto a spôsob uplatnenia reklamácie:</b>
        </p>
        <p>
          Kupujúci uplatňuje reklamáciu v predajni firmy Ďuriš v Kľačanoch počas
          otváracej doby.Zakúpenie reklamovaného tovaru kupujúci dokazuje príslušným
          predajným dokladom.Bez predloženia tohto dokladu nie je možné reklamáciu
          uznať. Kupujúci zaistí dopravu reklamovaného tovaru do predajne. Ak nie je
          možné z nejakého dôvodu dopraviť tovar do predajne, bude reklamácia
          vybavená po vzájomnej dohode kupujúceho s predávajúcim.
        </p>
        <p>
          <b>Spôsob uplatnenia nárokov z chýb:</b>
        </p>
        <p>
          Predávajúci poskytuje záruku za akosť len za podmienok stanovených v tomto
          Reklamačnom poriadku, ktoré musia byť splnené súčastne (v prípade
          nesplnenia ktorejkoľvek z nich záruka bez d'alšieho skončí:
        </p>
        <p>
          kupujúci urobil pri prevzatí produktov od predávajúceho či ihneď
          bezprostredne po dodaní produktov predávajúcim kvalifikovanú kontrolu
          dodaných produktov. V prípade že, kupujúci nepodal predávajúcemu písomnú
          správu o chybách produktov bez zbytočného odkladu po prevzatí produktov od
          predávajúceho, má sa za to, že produkty boli prevzaté bez chýb. Kupujúci
          uplatní nároky z chýb riadne a včas v súlade s týmto Reklamačným poriadkom.
          Po celú dobu trvania záručnej doby do produktu nezasiahne (napr. formou
          úprav alebo opráv) žiadna osoba, ktorá k tomu nie je výslovne poverená
          predávajúcim.Produkt bude kupujúcim užívaný len obvyklým spôsobom a v
          súladu s jeho účelovým určením a bude zaistená bežná údržba produktu.V
          prípade pochybnosti je kupujúci povinný preukázať, že produkt užíval v
          súlade podmienkami uvedenými reklamačného poriadku.
        </p>
        <p>
          Keď sa prejaví na produkte v záručnej dobe akákoľvek chyba, na ktorú sa
          vzťahuje záruka za akosť, je kupujúci povinný bez zbytočného odkladu,
          najneskôr do 24 hodín odo dňa, keď kupujúci prebral tovar, doručiť
          predávajúcemu písomné oznámenie o výskyte chýb produktu obsahujúci hlavne
          podrobný popis chyby, príp. ako sa chyba prejavuje. Písomné oznámenie
          kupujúci urobí formou reklamačného protokolu poslaného poštou, prip.mailom,
          alebo osobne. Keď sa prejaví na produkte v záručnej dobe akákoľvek chyba,
          na ktorú sa vzťahuje záruka, je kupujúci povinný zdržať sa akéhokoľvek
          zásahu do produktu a umožniť predávajúcemu prehliadku produktu; za tým
          účelom je kupujúci povinný chybný produkt predložiť súčastne s písomným
          oznámením predávajúcemu, poprípade osobám, ktorých prostredníctvom
          predávajúceho plní svoje záväzky alebo umožniť predávajúcemu, prípadne
          osobám, ktorých prostredníctvom predávajúceho plní svoje záväzky,
          neobmedzený prístup do miesta, v ktorom je chybný produkt umiestnený.
        </p>
        <p>
          <b>Neoprávnená reklamácia:</b>
        </p>
        <p>
          Záruka sa nevzťahuje na vady produktov spôsobené dopravou, pokiaľ ju
          zaisťuje kupujúci, dalej na vady vzniklé:bežným opotrebovaním; nesprávnym
          užívaním či nesprávnym skladovaním produktu;neodborným zásahom,
          inštaláciou, zaobchádzaním či obsluhou; neodborným zásahom sa rozumie tiež
          akékoľvek popisovanie produktu nezmývateľnými písacími
          prostriedkami;používanie, umiestňovanie, uskladňovanie produktov v
          nevhodných podmienkach pokiaľ ide o teplotu, vlhkosť, prašnosť;nesprávnou
          údržbou alebo zanedbaním potrebnej údržby;v dôsledku vyššej moci či
          nesprávne alebo neodborné manipulácie;v dôsledku jednania (konania či
          zabudnutí) tretej osoby alebo kupujúceho;v dôsledku užívania produktu iným
          než obvyklým spôsobom alebo v rozporu s jeho účelovým určením;na chyby
          spôsobené mechanickým alebo chemickým poškodením.
        </p>
        <p>
          Všetky náklady vzniklé predávajúcemu v dôsledku uplatnenia neoprávnenej
          reklamácie zo strany kupujúceho sa kupujúci zaväzuje predávajúcemu v plnej
          výške nahradiť.
        </p>
        <p>
          <b>Lehoty pre vybavenie reklamácie:</b>
        </p>
        <p>
          Reklamáciu produktu vybavuje predávajúci bez zbytočného odkladu, maximálne
          však do 30 dní od dátumu riadneho uplatnenia chýb produktu kupujúcim, tj.
          uplatnenie chýb produktu v súlade s týmto Reklamačným poriadkom. Lehota pre
          vybavenie reklamácie sa počíta odo dňa prijatia reklamácie predávajúcim do
          dňa vybavenia reklamácie predávajúcim. Oprávnenosť každej reklamácie a
          posúdenie odstrániteľnosti či neodstrániteľnosti chyby urobí zodpovedný
          pracovník predávajúceho a svoje stanovisko povie kupujúcemu v Reklamačnom
          protokole.
        </p>
        <!-- <p>
          <b>Záverečné ustanovenia:</b>
        </p>
        <p>
          Tento Reklamačný poriadok nadobúda účinnosti 01.7.2014. Tymto dátumom
          taktiež strácajú platnosť všetky predošlé verzie.
        </p>
        <p>
          Neoddeliteľnou prílohu tohoto Reklamačného poriadku tvorí vzor Reklamačného
          protokolu
        </p>
        <p>určené osoby reklamácie</p>
        <p>opravnene aybavovat : Mgr. Dagmar Durisova de</p>
        <p>Ing. Monika Plevová very</p>
        <p>Kľačany, 01.07.2014</p>-->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Header from "@/components/widgets/Header";
export default {
  name: "ReturnPolicy",
  components: {
    Header
  }
};
</script>

<style>
</style>